import { useMutation } from '@tanstack/react-query';

import { User } from 'src/features/auth/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { CreateUserFormSchemaValues } from 'src/features/users/utils/formSchema';

const RESOURCE = '/users/user/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: CreateUserFormSchemaValues): Promise<User> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateUser };
